// src/queryClient.ts
import { SwalAlert } from 'common/Swal/swal.common';
import { QueryClient } from 'react-query';
import Color from 'constants/color';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false, // ไม่ refetch เมื่อ window ได้รับโฟกัส
      staleTime: 10 * 60 * 1000, // กำหนดเวลาที่ข้อมูลจะถือว่าเก่า (10 นาที)
      cacheTime: 60 * 60 * 24 * 30 * 2 * 1000, // กำหนดเวลาที่ข้อมูลจะถูกเก็บใน cache (2 เดือน)
      // cacheTime: 30 * 60 * 1000, // กำหนดเวลาที่ข้อมูลจะถูกเก็บใน cache (30 นาที)
      retry: 0, // กำหนดจำนวนครั้งในการ retry หาก request ล้มเหลว
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000), // กำหนดเวลา delay ระหว่างการ retry
      onError: (error) => {
        if (error instanceof Error) {
          // แยกข้อความข้อผิดพลาดเพื่อเข้าถึง status code และ message
          const errorMessage = error?.message;
          const match = errorMessage.match(/status: (\d+) message: (.+) svgIcon: (.+) header: (.+) confirmButtonText: (.+) cancelButtonText: (.+)/);
          if (match) {
            const [, statusCode, message, svgIcon, header, confirmButtonText, cancelButtonText] = match;
            if(statusCode !== "404"){
              SwalAlert({
                icon: '',
                svgIcon: svgIcon,
                header: header,
                title: message,
                timer: 3000,
                showConfirmButton: true,
                confirmButtonText: confirmButtonText,
                showCloseButton: false,
                cancelButtonText: cancelButtonText,
                showCancelButton: false,
                reverseButtons: true,
                confirmButtonColor: Color.danger,
                then: async () => {}
              });
              console.error(`Error fetching data: Status Code ${statusCode}, Message: ${message}`);
            }
          } else {
            // ถ้าไม่สามารถแยกข้อความได้ ใช้ข้อความเดิม
            console.error('Error fetching data:', errorMessage);
          }
        } else {
          // ถ้า error ไม่ใช่ instance ของ Error, log ตามปกติ
          console.error('Error fetching data:', error);
        }
      },
      onSuccess: (data) => {
        // console.log(data)
        // console.log('Data fetched successfully:', data);
      }, // กำหนดฟังก์ชันที่จะถูกเรียกเมื่อ fetch ข้อมูลสำเร็จ
      onSettled: (data, error) => {
        // console.log('Query settled:', { data, error });
      }, // กำหนดฟังก์ชันที่จะถูกเรียกหลังจาก query สำเร็จหรือมี error
    },
    mutations: {
      // คุณสามารถตั้งค่าคอนฟิกสำหรับ mutations ที่นี่ หากต้องการ
      onError: (error) => {
        console.error('Error performing mutation:', error);
        // จัดการกับ error ทั่วไปของ mutations ที่นี่
      },
    },
  },
});